module.exports = __webpack_public_path__ + "img/ringbank.6c68f09.webp";